/**
 * Constants
 **/
const SHOW_MODAL = "modals/SHOW_MODAL";
const HIDE_MODAL = "modals/HIDE_MODAL";
const REMOVE_MODAL = "modals/REMOVE_MODAL";

/**
 * Reducer
 **/
export default function reducer(state = [], action) {
  switch (action.type) {
    case SHOW_MODAL:
      if (state.filter(modal => modal.modalType === action.modalType).length === 0) {
        // if modal not exist add new to modals array
        return [
          ...state,
          {
            modalType: action.modalType,
            modalProps: action.modalProps,
            isClosing: false,
          },
        ];
      } else {
        // eslint-disable-line no-else-return
        // else modal will be updated in array
        return state.map(modal => {
          let newModal;
          if (modal.modalType === action.modalType) {
            newModal = {
              modalType: action.modalType,
              modalProps: action.modalProps,
              isClosing: false,
            };
          } else {
            newModal = modal;
          }
          return newModal;
        });
      }
    case HIDE_MODAL:
      return state.map(modal => {
        if (modal.modalType === action.modalType) {
          return {
            ...modal,
            isClosing: true,
          };
        }
        return modal;
      });
    case REMOVE_MODAL:
      return state.filter(modal => modal.modalType !== action.modalType);
    default:
      return state;
  }
}

/**
 * Action Creators
 **/
export function showModal(modalType, modalProps) {
  return { type: SHOW_MODAL, modalType, modalProps };
}

export function hideModal(modalType) {
  return { type: HIDE_MODAL, modalType };
}

export function removeModal(modalType) {
  return { type: REMOVE_MODAL, modalType };
}



// WEBPACK FOOTER //
// ./src/redux/ducks/modals.js